// extracted by mini-css-extract-plugin
export default {"inputElement":"DatePicker_inputElement__uXsi0","error":"DatePicker_error__jKouO"};